<template>
  <header :class="{'sticky-header': true, 'header-with-username': checkEmailRoute}">
    <subscriber-header-top-vue
            v-on:loadUserEmails="loadUserEmails"
            v-if="0 === subscriberId">
    </subscriber-header-top-vue>
    <header-top-vue v-else />
    <header-bottom-vue
      :additional="additional"
      :heading="heading"
      :specific-link="'EMAIL'"
      :back-button="backButton"
    />
    <div>
      <list :backtoemailfolders="true" :isEditCicked="isEditCicked" ref="headerlist"/>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import HeaderBottomVue from "../../common/HeaderBottom";
import HeaderTopVue from "../../common/HeaderTop.vue";
import SubscriberHeaderTopVue from '../SubscriberHeaderTop.vue';
import List from "./List";

export default {
  props: {
    addNew: Boolean,
    hideNew: Function,
    additional: Object,
    isEditCicked: Boolean
  },
  computed: {
    ...mapGetters("favourites", {
      favouriteMode: "getFavouriteMode"
    }),
    ...mapGetters("portalemail", {
      subscriberId: "getSubscriberId"
    }),
    checkEmailRoute() {
      return ((this.$router.currentRoute.name === 'EmailDashboard') || (this.$router.currentRoute.name === 'EmailDetail'));
    },
    heading() {
      if (this.addNew) {
        return "Compose Email";
      } else if (this.favouriteMode) {
        return "Email Favorites";
      } else {
        return "Email";
      }
    },
    backButton() {
      return { show: this.addNew, action: this.hideNew };
    }
  },
  methods: {
    loadUserEmails() {
      this.$emit('loadUserEmails');
    }
  },
  components: {
    HeaderTopVue,
    SubscriberHeaderTopVue,
    HeaderBottomVue,
    List
  }
};
</script>

<style scoped>
header >>> .year-wrapper {
  position: absolute;
  left: 50%;
  top: 10px;
  transform: translateX(-50%);
  line-height: 18px;
}

@media (max-width: 450px) {
  header >>> .year-wrapper span {
    font-size: 18px !important;
  }
}
</style>
